import { Routes } from '@angular/router';
import { LandingPageComponent } from './layout/landing-page/landing-page.component';
import { PageNotFoundComponent } from './layout/page-not-found/page-not-found.component';
import { TokenResolverService } from './core/services/token-resolver.service';
import { AdminGuard } from './core/guards/admin.guard';
import { AccessDeniedComponent } from './layout/access-denied/access-denied.component';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  // {
  //   path: '',
  //   component: LandingPageComponent,
  //   pathMatch: 'full',
  //   canActivate: [AuthGuard]
  // },

  {
    path: '',
    pathMatch: 'full',
    loadChildren: () =>
      import('./features/report/report-base.module').then(
        (m) => m.ReportBaseModule
      ),
    resolve: { resolvedToken: TokenResolverService },
    canActivate: [AuthGuard]
  },
  { path: 'access-denied', component: AccessDeniedComponent },
  { path: '**', component: PageNotFoundComponent }
];
